import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from 'src/api';

import {
  AdminAddSchoolSignerRequest,
  AdminCreatePlacementRequest,
  AdminCreateProviderRequest,
  AdminCreateProviderResponse,
  AdminCreateStudentRequest,
  AdminPlacement,
  AdminProvider,
  AdminSchool,
  AdminStudent,
} from './adminSetup.types';

export const adminSetupApi = createApi({
  reducerPath: 'adminSetupApi',
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ['AdminSchools', 'AdminPlacements', 'AdminProviders', 'AdminStudents'],
  endpoints: (build) => ({
    createProvider: build.mutation<AdminCreateProviderResponse, AdminCreateProviderRequest>({
      query: (body) => ({ method: 'POST', url: '/admin/providers', body }),
      invalidatesTags: ['AdminProviders'],
    }),
    createStudent: build.mutation<AdminStudent, AdminCreateStudentRequest>({
      query: (body) => ({ method: 'POST', url: '/admin/students', body }),
      invalidatesTags: ['AdminStudents'],
    }),
    providers: build.query<AdminProvider[], { search?: string }>({
      query: ({ search }) =>
        `/admin/providers${search ? `?search=${encodeURIComponent(search)}` : ''}`,
      providesTags: ['AdminProviders'],
    }),
    students: build.query<AdminStudent[], { search?: string }>({
      query: ({ search }) =>
        `/admin/students${search ? `?search=${encodeURIComponent(search)}` : ''}`,
      providesTags: ['AdminStudents'],
    }),
    schools: build.query<AdminSchool[], { search?: string }>({
      query: ({ search }) =>
        `/admin/schools${search ? `?search=${encodeURIComponent(search)}` : ''}`,
      providesTags: ['AdminSchools'],
    }),
    addSchoolSigner: build.mutation<
      AdminSchool,
      { schoolId: string; body: AdminAddSchoolSignerRequest }
    >({
      query: ({ schoolId, body }) => ({
        method: 'POST',
        url: `/admin/schools/${schoolId}/signers`,
        body,
      }),
      invalidatesTags: ['AdminSchools'],
    }),
    createPlacement: build.mutation<AdminPlacement, AdminCreatePlacementRequest>({
      query: (body) => ({ method: 'POST', url: '/admin/placements', body }),
      invalidatesTags: ['AdminPlacements'],
    }),
    paraPlacements: build.query<AdminPlacement[], void>({
      query: () => '/admin/placements?serviceType=PARA',
      providesTags: ['AdminPlacements'],
    }),
  }),
});

export const {
  useCreateProviderMutation,
  useCreateStudentMutation,
  useProvidersQuery,
  useStudentsQuery,
  useSchoolsQuery,
  useAddSchoolSignerMutation,
  useCreatePlacementMutation,
  useParaPlacementsQuery,
} = adminSetupApi;
